import environment from 'bits/environment'
import { fetchLink } from '@padlet/arvo'
import { configure, getDisplayAttributes } from '@padlet/beethoven-client'

let beethovenApiHost = 'https://assets.padletcdn.com'
if (environment === 'staging') {
  beethovenApiHost = 'https://padlet.io'
} else if (environment === 'development') {
  beethovenApiHost = 'https://padlet.dev'
}
configure({ fetchLink, apiHost: beethovenApiHost })

export { getDisplayAttributes }
